import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region NAME

function _Name(props) {
    const data = props.data || {};
    const hasValue = !Utilities.isNullOrWhitespace(data.Name);
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />
}
const Name = withLabelTokenParsing(_Name, (props, keyword) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.Name:
            if (!Utilities.isNullOrWhitespace(data.Name)) {
                replaceString = data.Name;
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = () => [{ display: 'Name', token: Token.Name }];
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'PO:'})),
        style: LabelValueTypeConfig.panel.style,
        value: () => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Name}}`, token: Token.Name }))
    }
};

// #endregion NAME

export {
    Name as Component,
    Tokens,
    TypeConfig
}